import { IGetCalendarEvent } from '@interfaces/CalendarEvents'
import PortalCalendarEvent from './CalendarEvent'
import { flatten } from 'lodash'
import { StudentProfileInfo } from '@interfaces/Student'

class PortalCalendarEvents {
  calendarEvents: IGetCalendarEvent[]
  profile?: StudentProfileInfo

  constructor(calendarEvents: IGetCalendarEvent[], profile?: StudentProfileInfo) {
    this.calendarEvents = calendarEvents
    this.profile = profile
  }

  get ICS() {
    return flatten(
      this.calendarEvents.map(({ StudentCalendarEventInfo }) => {
        const sessions = StudentCalendarEventInfo?.SessionScheduleInfos || []
        const events = StudentCalendarEventInfo?.EventAttendeeInfos || []
        const name = `${this.profile?.FirstName || ''} ${this.profile?.LastName || ''}`
        const attendee = {
          name: name.replace(/\s/g, '') ? name : 'Attendee',
          email: StudentCalendarEventInfo.StudentContactEmail,
        }

        return [
          ...sessions?.map((session) => {
            return new PortalCalendarEvent(session, [attendee]).ICS
          }),
          ...events?.map((event) => {
            return new PortalCalendarEvent(event, [attendee]).ICS
          }),
        ]
      })
    )
  }
}

export default PortalCalendarEvents
